module.exports = __webpack_public_path__ + "static/whatcar-mobile-b7e6d8694cd1c713defa64e7b6bfc6ff.jpg";